/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Brand */
export enum Brand {
	Aspendental = 'aspendental',
	Chapter = 'chapter',
	Clearchoice = 'clearchoice',
}

/** EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE */
export interface EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventAdditionalPatientInformationValueEventTypeEnum;
	event_data: EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE_DATA;
}

/** EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE_DATA */
export interface EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Experiment Name */
	experiment_name?: string | null;
	/** First Name */
	first_name?: string | null;
	/** Last Name */
	last_name?: string | null;
	/** Date Of Birth */
	date_of_birth?: string | null;
	/** Email Address */
	email_address?: string | null;
	/** Mobile Phone */
	mobile_phone?: string | null;
	/** Home Phone */
	home_phone?: string | null;
	/** Is Insured */
	is_insured?: boolean | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_APPOINTMENTS_RETURNED_VALUE */
export interface EVENT_APPOINTMENTS_RETURNED_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventAppointmentsReturnedValueEventTypeEnum;
	event_data: EVENT_APPOINTMENTS_RETURNED_VALUE_DATA;
}

/** EVENT_APPOINTMENTS_RETURNED_VALUE_DATA */
export interface EVENT_APPOINTMENTS_RETURNED_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Experiment Name */
	experiment_name?: string | null;
	/** Visit Reason */
	visit_reason?: string | null;
	/** Visit Reason Subtype */
	visit_reason_subtype?: string | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_CONTINUE_WITHOUT_INSURANCE_VERIFICATION_VALUE */
export interface EVENT_CONTINUE_WITHOUT_INSURANCE_VERIFICATION_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventContinueWithoutInsuranceVerificationValueEventTypeEnum;
	event_data: EVENT_INSURANCE_ELIGIBILITY_VALUE_DATA;
}

/** EVENT_FIRST_DENTURE_RESPONSE_VALUE */
export interface EVENT_FIRST_DENTURE_RESPONSE_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventFirstDentureResponseValueEventTypeEnum;
	event_data: EVENT_FIRST_DENTURE_RESPONSE_VALUE_DATA;
}

/** EVENT_FIRST_DENTURE_RESPONSE_VALUE_DATA */
export interface EVENT_FIRST_DENTURE_RESPONSE_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Experiment Name */
	experiment_name?: string | null;
	/** Visit Reason */
	visit_reason?: string | null;
	/** Visit Reason Subtype */
	visit_reason_subtype?: string | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_INSURANCE_ELIGIBILITY_VALUE_DATA */
export interface EVENT_INSURANCE_ELIGIBILITY_VALUE_DATA {
	/** Patient Id */
	patient_id: string;
	/** Subscriber First Name */
	subscriber_first_name: string;
	/** Subscriber Last Name */
	subscriber_last_name: string;
	/** Subscriber Dob */
	subscriber_dob: string;
	/** Insurance Name */
	insurance_name: string;
	/** Member Id */
	member_id: string;
	/** Payer Id */
	payer_id: string;
	/** Eligible */
	eligible: boolean;
	/** Reverify */
	reverify: boolean;
	/** Adid */
	adid: string;
	/** Facility Code */
	facility_code: string;
	/** Session Id */
	session_id: string;
	/** Error Message */
	error_message?: string | null;
	/** Payer Supported */
	payer_supported?: boolean | null;
}

/** EVENT_INSURANCE_TAB_SWITCH_VALUE */
export interface EVENT_INSURANCE_TAB_SWITCH_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventInsuranceTabSwitchValueEventTypeEnum;
	event_data: EVENT_INSURANCE_TAB_SWITCH_VALUE_DATA;
}

/** EVENT_INSURANCE_TAB_SWITCH_VALUE_DATA */
export interface EVENT_INSURANCE_TAB_SWITCH_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code: string;
	/** Tab Name */
	tab_name: string;
	/** Edit Mode */
	edit_mode: boolean;
	/** Account Id */
	account_id: string;
	/** Patient Id */
	patient_id: string;
	/** Error Message */
	error_message: string;
	/** Adid */
	adid: string;
	/** User Type */
	user_type?: string | null;
}

/** EVENT_INSURANCE_VERIFICATION_VALUE */
export interface EVENT_INSURANCE_VERIFICATION_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventInsuranceVerificationValueEventTypeEnum;
	event_data: EVENT_INSURANCE_VERIFICATION_VALUE_DATA;
}

/** EVENT_INSURANCE_VERIFICATION_VALUE_DATA */
export interface EVENT_INSURANCE_VERIFICATION_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code: string;
	/** Insurance Company Name */
	insurance_company_name: string;
	/** Insurance Filing Priority Code */
	insurance_filing_priority_code: string;
	/** Insurance Code */
	insurance_code: string;
	/** Account Id */
	account_id: string;
	/** Patient Id */
	patient_id: string;
	/** Error Message */
	error_message: string;
	/** Adid */
	adid: string;
	/** User Type */
	user_type?: string | null;
	/** Claim Start Date */
	claim_start_date?: string | null;
	/** Date Effective */
	date_effective?: string | null;
	/** Coverage End Date */
	coverage_end_date?: string | null;
}

/** EVENT_MOTTO_POPUP_VALUE */
export interface EVENT_MOTTO_POPUP_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventMottoPopupValueEventTypeEnum;
	event_data: EVENT_MOTTO_POPUP_VALUE_DATA;
}

/** EVENT_MOTTO_POPUP_VALUE_DATA */
export interface EVENT_MOTTO_POPUP_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** First Name */
	first_name: string;
	/** Email Address */
	email_address: string;
	/** Last Name */
	last_name?: string | null;
	/** Date Of Birth */
	date_of_birth?: string | null;
	/** Zip Code */
	zip_code?: string | null;
	/** Visit Reason */
	visit_reason?: string | null;
	/** Mobile Phone */
	mobile_phone?: string | null;
	/** Home Phone */
	home_phone?: string | null;
	/** Is Insured */
	is_insured?: boolean | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_NEW_APPOINTMENT_VALUE */
export interface EVENT_NEW_APPOINTMENT_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventNewAppointmentValueEventTypeEnum;
	event_data: EVENT_NEW_APPOINTMENT_VALUE_DATA;
}

/** EVENT_NEW_APPOINTMENT_VALUE_DATA */
export interface EVENT_NEW_APPOINTMENT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Uri Query String */
	uri_query_string: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_PATIENT_INFORMATION_VALUE */
export interface EVENT_PATIENT_INFORMATION_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientInformationValueEventTypeEnum;
	event_data: EVENT_PATIENT_INFORMATION_VALUE_DATA;
}

/** EVENT_PATIENT_INFORMATION_VALUE_DATA */
export interface EVENT_PATIENT_INFORMATION_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Experiment Name */
	experiment_name?: string | null;
	/** First Name */
	first_name?: string | null;
	/** Last Name */
	last_name?: string | null;
	/** Date Of Birth */
	date_of_birth?: string | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_PATIENT_PREVIOUS_BALANCE_BYPASS_VALUE */
export interface EVENT_PATIENT_PREVIOUS_BALANCE_BYPASS_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientPreviousBalanceBypassValueEventTypeEnum;
	event_data: EVENT_PATIENT_PREVIOUS_BALANCE_BYPASS_VALUE_DATA;
}

/** EVENT_PATIENT_PREVIOUS_BALANCE_BYPASS_VALUE_DATA */
export interface EVENT_PATIENT_PREVIOUS_BALANCE_BYPASS_VALUE_DATA {
	/** Adid */
	adid: string;
	/** Facility Code */
	facility_code: string;
	/** Session Id */
	session_id: string;
	/** Bypass Reason Id */
	bypass_reason_id: number;
	/** Bypass Reason */
	bypass_reason: string;
	/** Patient Id */
	patient_id?: string | null;
	/** Appointment Id */
	appointment_id?: string | null;
	/** Patient Balance */
	patient_balance?: number | null;
	/** Patient Visit Charges */
	patient_visit_charges?: number | null;
}

/** EVENT_PATIENT_PREVIOUS_BALANCE_MAKE_PAYMENT_VALUE */
export interface EVENT_PATIENT_PREVIOUS_BALANCE_MAKE_PAYMENT_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientPreviousBalanceMakePaymentValueEventTypeEnum;
	event_data: EVENT_PATIENT_PREVIOUS_BALANCE_VALUE_DATA;
}

/** EVENT_PATIENT_PREVIOUS_BALANCE_SOFT_STOP_VALUE */
export interface EVENT_PATIENT_PREVIOUS_BALANCE_SOFT_STOP_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientPreviousBalanceSoftStopValueEventTypeEnum;
	event_data: EVENT_PATIENT_PREVIOUS_BALANCE_VALUE_DATA;
}

/** EVENT_PATIENT_PREVIOUS_BALANCE_VALUE_DATA */
export interface EVENT_PATIENT_PREVIOUS_BALANCE_VALUE_DATA {
	/** Adid */
	adid: string;
	/** Facility Code */
	facility_code: string;
	/** Session Id */
	session_id: string;
	/** Job Category */
	job_category?: string | null;
}

/** EVENT_PATIENT_VISIT_CHARGES_BYPASS_INELIGIBLE_VALUE */
export interface EVENT_PATIENT_VISIT_CHARGES_BYPASS_INELIGIBLE_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientVisitChargesBypassIneligibleValueEventTypeEnum;
	event_data: EVENT_PATIENT_PREVIOUS_BALANCE_VALUE_DATA;
}

/** EVENT_PATIENT_VISIT_CHARGES_BYPASS_VALUE */
export interface EVENT_PATIENT_VISIT_CHARGES_BYPASS_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientVisitChargesBypassValueEventTypeEnum;
	event_data: EVENT_PATIENT_PREVIOUS_BALANCE_BYPASS_VALUE_DATA;
}

/** EVENT_PATIENT_VISIT_CHARGES_MAKE_PAYMENT_VALUE */
export interface EVENT_PATIENT_VISIT_CHARGES_MAKE_PAYMENT_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientVisitChargesMakePaymentValueEventTypeEnum;
	event_data: EVENT_PATIENT_PREVIOUS_BALANCE_VALUE_DATA;
}

/** EVENT_PATIENT_VISIT_CHARGES_SEMI_HARD_STOP_VALUE */
export interface EVENT_PATIENT_VISIT_CHARGES_SEMI_HARD_STOP_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientVisitChargesSemiHardStopValueEventTypeEnum;
	event_data: EVENT_PATIENT_PREVIOUS_BALANCE_VALUE_DATA;
}

/** EVENT_REASON_FOR_VISIT_VALUE */
export interface EVENT_REASON_FOR_VISIT_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventReasonForVisitValueEventTypeEnum;
	event_data: EVENT_REASON_FOR_VISIT_VALUE_DATA;
}

/** EVENT_REASON_FOR_VISIT_VALUE_DATA */
export interface EVENT_REASON_FOR_VISIT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Experiment Name */
	experiment_name?: string | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_REASON_RESPONSE_VALUE */
export interface EVENT_REASON_RESPONSE_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventReasonResponseValueEventTypeEnum;
	event_data: EVENT_REASON_RESPONSE_VALUE_DATA;
}

/** EVENT_REASON_RESPONSE_VALUE_DATA */
export interface EVENT_REASON_RESPONSE_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Experiment Name */
	experiment_name?: string | null;
	/** Visit Reason */
	visit_reason?: string | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_REVERIFY_INSURANCE_ELIGIBILITY_VALUE */
export interface EVENT_REVERIFY_INSURANCE_ELIGIBILITY_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventReverifyInsuranceEligibilityValueEventTypeEnum;
	event_data: EVENT_INSURANCE_ELIGIBILITY_VALUE_DATA;
}

/** EVENT_REVIEW_APPOINTMENT_VALUE */
export interface EVENT_REVIEW_APPOINTMENT_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventReviewAppointmentValueEventTypeEnum;
	event_data: EVENT_REVIEW_APPOINTMENT_VALUE_DATA;
}

/** EVENT_REVIEW_APPOINTMENT_VALUE_DATA */
export interface EVENT_REVIEW_APPOINTMENT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string | null;
	/** Experiment Name */
	experiment_name?: string | null;
	/** First Name */
	first_name?: string | null;
	/** Last Name */
	last_name?: string | null;
	/** Date Of Birth */
	date_of_birth?: string | null;
	/** Email Address */
	email_address?: string | null;
	/** Mobile Phone */
	mobile_phone?: string | null;
	/** Home Phone */
	home_phone?: string | null;
	/** Is Insured */
	is_insured?: boolean | null;
	/** Visit Reason */
	visit_reason?: string | null;
	/** Visit Reason Subtype */
	visit_reason_subtype?: string | null;
	/** Appointment Start */
	appointment_start?: string | null;
	/** Appointment End */
	appointment_end?: string | null;
	/** Client Id */
	client_id?: string | null;
}

/** EVENT_SUBMIT_ASSESSMENT_VALUE */
export interface EVENT_SUBMIT_ASSESSMENT_VALUE {
	/** Timestamp */
	timestamp: string;
	/** Event Type */
	event_type: EventSubmitAssessmentValueEventTypeEnum;
	event_data: EVENT_SUBMIT_ASSESSMENT_VALUE_DATA;
}

/** EVENT_SUBMIT_ASSESSMENT_VALUE_DATA */
export interface EVENT_SUBMIT_ASSESSMENT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Age Demographic */
	age_demographic: string;
	/** Consideration Reason */
	consideration_reason: string;
	/** Previous Ortho Appliance */
	previous_ortho_appliance: string;
	/** Type Of Insurance */
	type_of_insurance: string;
	/** Teeth Crowding Severity */
	teeth_crowding_severity: string;
	/** Teeth Spacing Severity */
	teeth_spacing_severity: string;
	/** First Name */
	first_name: string;
	/** Last Name */
	last_name: string;
	/** Email Address */
	email_address: string;
	/** Zip Code */
	zip_code: string;
	/** Client Id */
	client_id?: string | null;
	/** Facility Code */
	facility_code?: string | null;
}

/** FormData */
export interface FormData {
	/** Brand */
	brand: string;
	/** Product Line */
	product_line: string;
	/** Session Id */
	session_id: string;
	/** Form Title */
	form_title: string;
	/** Form Type */
	form_type: string;
	/** Form Channel */
	form_channel: string;
	/** Form Questions */
	form_questions: FormQuestion[];
	/** Form Description */
	form_description?: string | null;
	/** Form Result */
	form_result?: string | null;
}

/** FormQuestion */
export interface FormQuestion {
	/** Question */
	question: string;
	/** Answer */
	answer: string;
	/** Unique Label */
	unique_label?: string | null;
}

/** FormSubmission */
export interface FormSubmission {
	form: FormData;
}

/** HTTPValidationError */
export interface HTTPValidationError {
	/** Detail */
	detail?: ValidationError[];
}

/** ValidationError */
export interface ValidationError {
	/** Location */
	loc: (string | number)[];
	/** Message */
	msg: string;
	/** Error Type */
	type: string;
}

/** Event */
export type UserEventsValidationEventValidationsEvent =
	| EVENT_NEW_APPOINTMENT_VALUE
	| EVENT_REASON_FOR_VISIT_VALUE
	| EVENT_REASON_RESPONSE_VALUE
	| EVENT_FIRST_DENTURE_RESPONSE_VALUE
	| EVENT_APPOINTMENTS_RETURNED_VALUE
	| EVENT_PATIENT_INFORMATION_VALUE
	| EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE
	| EVENT_REVIEW_APPOINTMENT_VALUE
	| EVENT_SUBMIT_ASSESSMENT_VALUE
	| EVENT_MOTTO_POPUP_VALUE
	| EVENT_INSURANCE_VERIFICATION_VALUE
	| EVENT_INSURANCE_TAB_SWITCH_VALUE
	| EVENT_REVERIFY_INSURANCE_ELIGIBILITY_VALUE
	| EVENT_CONTINUE_WITHOUT_INSURANCE_VERIFICATION_VALUE
	| EVENT_PATIENT_PREVIOUS_BALANCE_SOFT_STOP_VALUE
	| EVENT_PATIENT_PREVIOUS_BALANCE_MAKE_PAYMENT_VALUE
	| EVENT_PATIENT_PREVIOUS_BALANCE_BYPASS_VALUE
	| EVENT_PATIENT_VISIT_CHARGES_SEMI_HARD_STOP_VALUE
	| EVENT_PATIENT_VISIT_CHARGES_MAKE_PAYMENT_VALUE
	| EVENT_PATIENT_VISIT_CHARGES_BYPASS_VALUE
	| EVENT_PATIENT_VISIT_CHARGES_BYPASS_INELIGIBLE_VALUE;

/** Event */
export interface UserEventsValidationEventsEvent {
	brand: Brand;
	/** Event Type */
	event_type: string;
	/** Event Data */
	event_data: object;
	/** Timestamp */
	timestamp?: string | null;
}

/** Event Type */
export enum EventAdditionalPatientInformationValueEventTypeEnum {
	AdditionalPatientInfo = 'additional_patient_info',
}

/** Event Type */
export enum EventAppointmentsReturnedValueEventTypeEnum {
	AvailableAppointmentsReturned = 'available_appointments_returned',
}

/** Event Type */
export enum EventContinueWithoutInsuranceVerificationValueEventTypeEnum {
	ContinueWithoutInsuranceVerification = 'continue_without_insurance_verification',
}

/** Event Type */
export enum EventFirstDentureResponseValueEventTypeEnum {
	FirstTimeDentureResponse = 'first_time_denture_response',
}

/** Event Type */
export enum EventInsuranceTabSwitchValueEventTypeEnum {
	InsuranceTabSwitch = 'insurance_tab_switch',
}

/** Event Type */
export enum EventInsuranceVerificationValueEventTypeEnum {
	InsuranceVerification = 'insurance_verification',
}

/** Event Type */
export enum EventMottoPopupValueEventTypeEnum {
	MottoAbandonedPopup = 'motto_abandoned_popup',
}

/** Event Type */
export enum EventNewAppointmentValueEventTypeEnum {
	ScheduleAnAppointment = 'schedule_an_appointment',
}

/** Event Type */
export enum EventPatientInformationValueEventTypeEnum {
	PatientInfo = 'patient_info',
}

/** Event Type */
export enum EventPatientPreviousBalanceBypassValueEventTypeEnum {
	PatientPreviousBalanceBypass = 'patient_previous_balance_bypass',
}

/** Event Type */
export enum EventPatientPreviousBalanceMakePaymentValueEventTypeEnum {
	PatientPreviousBalanceMakePayment = 'patient_previous_balance_make_payment',
}

/** Event Type */
export enum EventPatientPreviousBalanceSoftStopValueEventTypeEnum {
	PatientPreviousBalanceSoftStop = 'patient_previous_balance_soft_stop',
}

/** Event Type */
export enum EventPatientVisitChargesBypassIneligibleValueEventTypeEnum {
	PatientVisitChargesBypassIneligible = 'patient_visit_charges_bypass_ineligible',
}

/** Event Type */
export enum EventPatientVisitChargesBypassValueEventTypeEnum {
	PatientVisitChargesBypass = 'patient_visit_charges_bypass',
}

/** Event Type */
export enum EventPatientVisitChargesMakePaymentValueEventTypeEnum {
	PatientVisitChargesMakePayment = 'patient_visit_charges_make_payment',
}

/** Event Type */
export enum EventPatientVisitChargesSemiHardStopValueEventTypeEnum {
	PatientVisitChargesSemiHardStop = 'patient_visit_charges_semi_hard_stop',
}

/** Event Type */
export enum EventReasonForVisitValueEventTypeEnum {
	ReasonForVisit = 'reason_for_visit',
}

/** Event Type */
export enum EventReasonResponseValueEventTypeEnum {
	ReasonForVisitResponse = 'reason_for_visit_response',
}

/** Event Type */
export enum EventReverifyInsuranceEligibilityValueEventTypeEnum {
	VerifyInsuranceEligibility = 'verify_insurance_eligibility',
}

/** Event Type */
export enum EventReviewAppointmentValueEventTypeEnum {
	AppointmentReview = 'appointment_review',
}

/** Event Type */
export enum EventSubmitAssessmentValueEventTypeEnum {
	SubmitSmileAssessment = 'submit_smile_assessment',
}
